<template>
  <div class="waf-component waf-fantasy-contests">
    <div class="layout-wrapper">
      <div class="waf-head">
        <h3 class="widget-title">{{ titleTxt() }}</h3>
      </div>
      <div class="waf-body" v-if="contest_loaded">
        <div class="contest-list" v-if="contests_list && contests_list.length">
          <a
            :class="['contest-item img-1by1', {'disabled': current_match.status !== 1}]"
            v-for="(contest_details, idx) in contests_list"
            v-bind:key="idx"
            v-bind:href="getRedirectURL(contest_details)"
            target="_blank"
            @click="onContestClick(contest_details, $event)"
            rel="nofollow"
          >
            <div class="contest-thumbnail">
              <div class="img-box">
                <img
                  :src="getImageUrl(contest_details)"
                  :alt="contest_details.cid"
                  class="loading"
                />
              </div>
            </div>
            <div class="contest-info">
              <div class="info-wrap">
                <div class="info-section1">
                  <div class="info-section-wrap">
                    <div class="name">
                      {{ translations.currency_symbol }}
                      {{ convert_number(contest_details.tp) }}
                    </div>
                    <div class="price-detail">
                      <span class="entry-fee"
                        >{{ translations.entry }}
                        {{ translations.currency_symbol }}
                        {{ convert_number(contest_details.ef) }}</span
                      >
                      <span class="spot"
                        >{{ translations.spots }}:
                        {{
                          Number(contest_details.pc).toLocaleString("en-IN")
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="contest-rating">
                    <span class="profit">{{
                      translations.approx_winnings
                    }}</span>
                    <span
                      :class="[
                        'rating',
                        contest_details.ar < 0
                          ? 'loss'
                          : contest_details.ar !== 0
                          ? 'success'
                          : '',
                      ]"
                      >{{ translations.currency_symbol }}
                      {{ convert_number(contest_details.mp) }}</span
                    >
                  </div>
                </div>
                <div class="info-section2">
                  <span class="prize-pool"
                    >{{ translations.top_prize }}:
                    {{ translations.currency_symbol }}
                    {{ convert_number(contest_details.hp) }}</span
                  >
                  <span class="winning">
                    {{
                      getParticipantBracket(
                        contest_details,
                        translations.contestType
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="contest-list" v-else>
          <div class="no-data">
            <p class="msg">{{ translations.noContestsFound }}</p>
          </div>
        </div>
        <div class="btn-wrap" v-if="contests_list && contests_list.length">
          <a class="btn btn-link" :href="getViewAllLink()"><span>{{translations.viewAll}}</span>({{contest_count}})</a>
        </div>
        <p class="disclaimer-txt" v-if="contests_list && contests_list.length">{{translations.contestDisclaimer}}</p>
      </div>
      <div class="waf-body" v-else>
        <div class="contest-list">
          <a
            class="contest-item img-1by1"
            v-for="c in [1,2,3]"
            v-bind:key="c"
            rel="nofollow"
          >
            <div class="contest-thumbnail shimmer">
              <div class="img-box"></div>
            </div>
            <div class="contest-info shimmer">
              <div class="info-wrap"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CFG_WIDGET_URL_BASE,
  CFG_PLATFORM_IMAGE_DOMAIN,
  CFG_CUSTOM_CONTEST_REDIRECTS,
  CFG_CONTEST_PARTICIPANT_BRACKETS,
  CFG_UTM_PARAMS,
  CFG_MODULES,
  CFG_TRACKING,
} from "../../../assets/js/config";
import { addPagePropertiesToObject, convertNumber, formatFullUrl, sendTrackingData } from "../../../assets/js/common";
export default {
  props: ["current_match"],
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    is_pre_match() {
      let curr_match = this.current_match;
      return !!(curr_match && curr_match.status === 1);
    },
    contest_loaded() {
      return this.$store.state.team_store.contest_loaded;
    },
    contests_list() {
      if(this.$store.state && this.$store.state.team_store){
        return this.$store.state.team_store.selectedMatchContests;
      } else {
        return [];
      }
    },
    contest_count() {
      if(this.$store.state && this.$store.state.team_store) {
        return this.$store.state.team_store.contest_count;
      } else {
        return 0;
      }
    },
  },
  methods: {
    titleTxt() {
      let trans = this.translations;
      let text = trans.contestWidgetTitle;
      let vsTxt = "";
      if (
        this.current_match &&
        this.current_match.teams &&
        this.current_match.teams.length
      ) {
        vsTxt = `${this.current_match.teams[0].short_name} ${trans.vs_label} ${this.current_match.teams[1].short_name}`;
      }
      return text.replace("{{teams}}", vsTxt);
    },
    getParticipantBracket(contest_details, outputText) {
      let bracket = CFG_CONTEST_PARTICIPANT_BRACKETS.find(
        (cp) => contest_details.pc >= cp.min && contest_details.pc <= cp.max
      );
      let bracketVal =
        bracket && bracket.contestType ? bracket.contestType : "-";
      return outputText.replace("{{type}}", bracketVal);
    },
    getRedirectURL(contest_details) {
      if (this.current_match.status !== 1) {
        return null;
      }
      if (CFG_CUSTOM_CONTEST_REDIRECTS[contest_details.pid]) {
        return CFG_CUSTOM_CONTEST_REDIRECTS[contest_details.pid].redirect_url;
      }
      return contest_details.cu !== "" && this.addUtmParams(contest_details.cu);
    },
    addUtmParams: function (cu) {
      if (!cu) return cu;
      let url = new URL(cu);
      Object.keys(CFG_UTM_PARAMS).forEach((key) => {
        url.searchParams.set(key, CFG_UTM_PARAMS[key]);
      });
      return url;
    },
    onContestClick: function (contest_details, event) {
      //condition added if current match is expired one
      if (this.current_match.status !== 1) {
        event.stopPropagation();
        event.preventDefault();
        return false;
      }

      let { cid, pn } = contest_details;
      let toTrack = CFG_TRACKING["21"];
      toTrack.value = cid;
      toTrack.label = pn;
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    convert_number: function (val) {
      return convertNumber(val);
    },
    getImageUrl: function (contest_details) {
      return (
        CFG_WIDGET_URL_BASE + CFG_PLATFORM_IMAGE_DOMAIN + contest_details.pi
      );
    },
    getViewAllLink: function () {
      let match = this.current_match;
      if (typeof match !== "undefined") {
        let route = CFG_MODULES.GAME_PLAN.route;
        let matchUrl = formatFullUrl(match, route);
        return (CFG_WIDGET_URL_BASE + matchUrl);
      } else {
        return null;
      }
    },
  },
};
</script>
